/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:55 2019-07-10
 */

import {Component} from 'vue-property-decorator'
import AuthLogConfigService from "./service/authLogConfigService"
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import { AuthLogConfigDOI } from './api/authLogConfigApi'

@Component
export default class AuthLogConfig extends BasicSearchPage<AuthLogConfigService, AuthLogConfigDOI.RowDataI, AuthLogConfigDOI.QueryRowDataParamsI> {
    @override
    renderHead(h) {
       return <div></div>
    }
    
    @override
    loadService () {
       this.service = new AuthLogConfigService(this)
    }
    
}
